import { Controller, useFormContext } from "react-hook-form";
import CustomInput from "../../../Common/CustomInput";

export const NSPQuestionItem = ({ questionName }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <div style={{ display: "flex", gap: "20px" }}>
                <Controller
                    control={control}
                    name={`${questionName}.lowerLabel`}
                    render={({ field }) => (
                        <CustomInput
                            errors={errors}
                            label="Lower Label *"
                            {...field}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`${questionName}.upperLabel`}
                    render={({ field }) => (
                        <CustomInput
                            errors={errors}
                            label="Upper Label *"
                            {...field}
                        />
                    )}
                />
            </div>
        </div>
    );
};
